// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectBuildingUseStatusQueryResult, selectBuildingUseStatussPageLoading, selectBuildingUseStatussShowInitWaitingMessage} from '../_selectors/building-use-status.selectors';

export class BuildingUseStatussDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectBuildingUseStatussPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectBuildingUseStatussShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectBuildingUseStatusQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
